/* ZENKIO STORM — interactions. Vanilla JS, aucune dépendance. */
(function () {
  'use strict';
  var ZK = window.ZK || {};
  ZK.labels = ZK.labels || {};
  ZK.routes = ZK.routes || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var clamp = function (v, a, b) { return Math.min(b, Math.max(a, v)); };
  var lerp = function (a, b, t) { return a + (b - a) * t; };
  var store = {
    get: function (k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  };

  /* ---------- Money ---------- */
  function money(cents) {
    var fmt = ZK.moneyFormat || '{{amount}} €';
    cents = Number(cents) || 0;
    function f(n, d, ts, ds) {
      var s = (n / 100).toFixed(d).split('.');
      return s[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts) + (s[1] ? ds + s[1] : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount_no_decimals': return f(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return f(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return f(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return f(cents, 2, "'", '.');
        case 'amount_with_space_separator': return f(cents, 2, ' ', ',');
        default: return f(cents, 2, ',', '.');
      }
    }).replace(/<[^>]*>/g, '');
  }
  ZK.money = money;

  /* ---------- Loader ---------- */
  function loader() {
    var el = $('[data-loader]');
    if (!el) { document.dispatchEvent(new Event('zk:ready')); return; }
    if (store.get('zk-loaded') || reduce) {
      el.classList.add('is-gone');
      document.dispatchEvent(new Event('zk:ready'));
      return;
    }
    document.documentElement.style.overflow = 'hidden';
    var num = $('[data-loader-num]', el), bar = $('[data-loader-bar]', el), st = $('[data-loader-status]', el);
    var start = performance.now(), dur = 1700, steps = ['FORMATION DE LA TEMPÊTE…', 'CHUTE DE PRESSION…', 'VENTS VIOLENTS DÉTECTÉS…', 'ALERTE ROUGE.'];
    (function tick(now) {
      var p = clamp((now - start) / dur, 0, 1), e = 1 - Math.pow(1 - p, 3);
      num.textContent = String(Math.round(1013 - e * 53)).padStart(4, '0');
      bar.style.width = (e * 100) + '%';
      st.textContent = steps[Math.min(steps.length - 1, Math.floor(p * steps.length))];
      if (p < 1) return requestAnimationFrame(tick);
      el.classList.add('is-flash');
      setTimeout(function () { el.classList.remove('is-flash'); el.classList.add('is-done'); document.documentElement.style.overflow = ''; document.dispatchEvent(new Event('zk:ready')); }, 120);
      setTimeout(function () { el.classList.add('is-gone'); }, 1200);
      store.set('zk-loaded', '1');
    })(start);
  }

  /* ---------- Clock ---------- */
  function clocks() {
    var els = $$('[data-clock]');
    if (!els.length) return;
    function run() {
      els.forEach(function (el) {
        try {
          el.textContent = new Date().toLocaleTimeString('fr-BE', { timeZone: el.dataset.tz || 'Europe/Brussels', hour12: false });
        } catch (e) { el.textContent = new Date().toLocaleTimeString('fr-BE', { hour12: false }); }
      });
    }
    run(); setInterval(run, 1000);
  }

  /* ---------- Split chars ---------- */
  function splitChars() {
    $$('[data-split]').forEach(function (el, li) {
      var txt = el.textContent; el.setAttribute('aria-label', txt); el.textContent = '';
      Array.prototype.forEach.call(txt, function (ch, i) {
        var s = document.createElement('span');
        s.className = 'zk-char'; s.setAttribute('aria-hidden', 'true');
        s.style.setProperty('--ci', i); s.style.setProperty('--d0', (li * 180) + 'ms');
        s.textContent = ch === ' ' ? ' ' : ch;
        el.appendChild(s);
      });
    });
  }

  /* ---------- Fit hero title: one size, widest line fills the width ---------- */
  function fitLines() {
    var title = $('[data-fit]'); if (!title) return;
    var lines = $$('.zk-hero__line', title);
    function run() {
      var box = $('.zk-hero__content'); if (!box) return;
      var cs = getComputedStyle(box);
      var max = box.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight) - (innerWidth > 989 ? 60 : 4);
      title.style.fontSize = '';
      var base = parseFloat(getComputedStyle(title).fontSize), widest = 0;
      lines.forEach(function (l) { var i = l.firstElementChild; if (i) widest = Math.max(widest, i.scrollWidth); });
      if (!widest) return;
      var cap = innerWidth > 989 ? Math.min(220, innerHeight * .17) : 120;
      title.style.fontSize = Math.min(cap, base * max / widest) + 'px';
    }
    run(); addEventListener('resize', run);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(run);
  }

  /* ---------- Scramble ---------- */
  function scramble() {
    if (!finePointer) return;
    var glyphs = 'ZENKIO#/\\_-+*⚡01';
    $$('[data-scramble]').forEach(function (el) {
      var orig = el.textContent, running = false;
      el.addEventListener('mouseenter', function () {
        if (running) return; running = true; var f = 0;
        var iv = setInterval(function () {
          el.textContent = orig.split('').map(function (c, i) {
            if (c === ' ' || i < f / 2) return c;
            return glyphs[Math.floor(Math.random() * glyphs.length)];
          }).join('');
          f++; if (f / 2 >= orig.length) { clearInterval(iv); el.textContent = orig; running = false; }
        }, 28);
      });
    });
  }

  /* ---------- Cursor + magnet ---------- */
  function cursor() {
    if (!ZK.cursor || !finePointer || reduce) return;
    var c = $('.zk-cursor'); if (!c) return;
    document.documentElement.classList.add('has-cursor');
    var dot = $('.zk-cursor__dot', c), lab = $('.zk-cursor__label', c);
    addEventListener('pointermove', function (e) {
      c.style.transform = 'translate3d(' + e.clientX + 'px,' + e.clientY + 'px,0)';
    }, { passive: true });
    document.addEventListener('pointerover', function (e) {
      var t = e.target.closest('a, button, label, input, select, [data-cursor]');
      var withLabel = e.target.closest('[data-cursor]');
      c.classList.toggle('is-hover', !!t);
      c.classList.toggle('is-label', !!withLabel);
      lab.textContent = withLabel ? withLabel.dataset.cursor : '';
    });
    document.addEventListener('pointerleave', function () { c.style.opacity = 0; });
    document.addEventListener('pointerenter', function () { c.style.opacity = 1; });
  }
  function buttons() {
    $$('.zk-btn').forEach(function (b) {
      b.addEventListener('pointermove', function (e) {
        var r = b.getBoundingClientRect();
        b.style.setProperty('--mx', ((e.clientX - r.left) / r.width * 100) + '%');
        b.style.setProperty('--my', ((e.clientY - r.top) / r.height * 100) + '%');
      });
    });
    if (!finePointer || reduce) return;
    $$('[data-magnet]').forEach(function (b) {
      b.addEventListener('pointermove', function (e) {
        var r = b.getBoundingClientRect();
        b.style.transform = 'translate(' + (e.clientX - r.left - r.width / 2) * .25 + 'px,' + (e.clientY - r.top - r.height / 2) * .35 + 'px)';
      });
      b.addEventListener('pointerleave', function () { b.style.transform = ''; });
    });
  }

  /* ---------- Storm (rain + lightning) ---------- */
  var wind = { v: 0, target: 0 };
  function storm() {
    $$('[data-hero]').forEach(function (hero) {
      var cv = $('[data-storm]', hero); if (!cv) return;
      var flash = $('[data-flash]', hero);
      var ctx = cv.getContext('2d'), w, h, dpr = Math.min(devicePixelRatio || 1, 2), drops = [], bolt = null, visible = true;
      function size() {
        w = cv.clientWidth; h = cv.clientHeight; cv.width = w * dpr; cv.height = h * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        var n = Math.round(w * h / (reduce ? 20000 : 5200));
        drops = []; for (var i = 0; i < n; i++) drops.push(newDrop(true));
      }
      function newDrop(any) {
        var z = Math.random();
        return { x: Math.random() * (w + 200) - 100, y: any ? Math.random() * h : -20, l: 8 + z * 26, s: 9 + z * 20, a: .08 + z * .32, z: z };
      }
      function makeBolt() {
        var x = w * (.15 + Math.random() * .7), y = 0, pts = [[x, y]], branches = [];
        while (y < h * (.55 + Math.random() * .35)) {
          x += (Math.random() - .5) * 70; y += 12 + Math.random() * 26; pts.push([x, y]);
          if (Math.random() < .12) { var bx = x, by = y, b = [[bx, by]]; for (var k = 0; k < 6; k++) { bx += (Math.random() - .3) * 50; by += 14 + Math.random() * 18; b.push([bx, by]); } branches.push(b); }
        }
        return { pts: pts, branches: branches, life: 1 };
      }
      function strike() {
        if (!visible || reduce) return schedule();
        bolt = makeBolt();
        hero.classList.add('is-flash');
        if (flash) { flash.style.transition = 'none'; flash.style.opacity = .9; requestAnimationFrame(function () { flash.style.transition = 'opacity .7s'; flash.style.opacity = 0; }); }
        setTimeout(function () { hero.classList.remove('is-flash'); }, 90);
        setTimeout(function () { if (Math.random() < .5) { hero.classList.add('is-flash'); setTimeout(function () { hero.classList.remove('is-flash'); }, 60); } }, 180);
        hits();
        schedule();
      }
      function hits() {
        var chars = $$('.zk-hero__line--outline .zk-char', hero);
        if (!chars.length) return;
        for (var i = 0; i < 3; i++) {
          var c = chars[Math.floor(Math.random() * chars.length)];
          c.classList.add('is-hit');
          (function (cc) { setTimeout(function () { cc.classList.remove('is-hit'); }, 260); })(c);
        }
      }
      function schedule() { setTimeout(strike, 3500 + Math.random() * 6000); }
      function path(p) { ctx.beginPath(); ctx.moveTo(p[0][0], p[0][1]); for (var i = 1; i < p.length; i++) ctx.lineTo(p[i][0], p[i][1]); ctx.stroke(); }
      function frame() {
        if (visible) {
          ctx.clearRect(0, 0, w, h);
          wind.v = lerp(wind.v, wind.target, .04);
          var slant = .18 + wind.v * .9;
          ctx.lineCap = 'round';
          for (var i = 0; i < drops.length; i++) {
            var d = drops[i];
            ctx.strokeStyle = 'rgba(235,235,230,' + d.a + ')'; ctx.lineWidth = .6 + d.z * .9;
            ctx.beginPath(); ctx.moveTo(d.x, d.y); ctx.lineTo(d.x - d.l * slant, d.y + d.l); ctx.stroke();
            d.y += d.s; d.x -= d.s * slant;
            if (d.y > h || d.x < -120) drops[i] = newDrop(false);
          }
          if (bolt) {
            ctx.shadowColor = '#fff'; ctx.shadowBlur = 24;
            ctx.strokeStyle = 'rgba(255,255,255,' + bolt.life + ')'; ctx.lineWidth = 2.6; path(bolt.pts);
            ctx.lineWidth = 1; bolt.branches.forEach(path);
            ctx.shadowBlur = 0;
            bolt.life -= .06; if (bolt.life <= 0) bolt = null;
          }
        }
        requestAnimationFrame(frame);
      }
      if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }).observe(hero);
      size(); addEventListener('resize', size);
      requestAnimationFrame(frame);
      if (hero.dataset.lightning !== 'false' && !reduce) setTimeout(strike, 1800);
    });
  }

  /* ---------- Storm title displacement + hero parallax + HUD ---------- */
  function heroFx() {
    var turb = $('#zk-storm-filter feTurbulence'), disp = $('#zk-storm-filter feDisplacementMap');
    var hero = $('.zk-hero');
    var windEl = $('[data-wind]'), dirEl = $('[data-dir]');
    var lastX = 0, lastY = 0, speed = 0, t = 0;
    var dirs = ['N', 'NE', 'E', 'SE', 'S', 'SO', 'O', 'NO'];
    addEventListener('pointermove', function (e) {
      var dx = e.clientX - lastX, dy = e.clientY - lastY;
      speed = Math.min(80, speed + Math.sqrt(dx * dx + dy * dy) * .25);
      wind.target = clamp(-dx / 40, -.6, .6);
      lastX = e.clientX; lastY = e.clientY;
      if (hero && finePointer && !reduce) {
        hero.style.setProperty('--px', ((e.clientX / innerWidth) - .5) * -24 + 'px');
        hero.style.setProperty('--py', ((e.clientY / innerHeight) - .5) * -24 + 'px');
      }
      if (dirEl) { var a = Math.atan2(dy, dx) * 180 / Math.PI + 90; dirEl.textContent = dirs[(Math.round(((a + 360) % 360) / 45)) % 8]; }
    }, { passive: true });
    if (!turb || reduce) return;
    (function loop() {
      t += .008; speed *= .94; wind.target *= .985;
      var fx = .006 + Math.sin(t) * .002, fy = .018 + Math.cos(t * 1.3) * .006;
      turb.setAttribute('baseFrequency', fx.toFixed(4) + ' ' + fy.toFixed(4));
      disp.setAttribute('scale', (2.5 + speed * .18).toFixed(1));
      if (windEl) windEl.textContent = String(Math.round(38 + speed * 1.4 + Math.sin(t * 3) * 4)).padStart(3, '0');
      requestAnimationFrame(loop);
    })();
  }

  /* ---------- Velocity marquee ---------- */
  function marquees() {
    var bands = $$('[data-velocity-marquee]'); if (!bands.length) return;
    var lastY = scrollY, vel = 0;
    var items = bands.map(function (b) { return { el: $('.zk-ticker__track', b), x: 0, dir: 1, w: 0 }; });
    function measure() { items.forEach(function (it) { var g = $('.zk-ticker__group', it.el); it.w = g ? g.offsetWidth : 0; }); }
    measure(); addEventListener('resize', measure);
    (function loop() {
      var dy = scrollY - lastY; lastY = scrollY;
      vel = lerp(vel, dy, .1);
      items.forEach(function (it, i) {
        if (Math.abs(dy) > 1) it.dir = dy > 0 ? 1 : -1;
        var base = reduce ? 0 : 1.1;
        it.x -= (base + Math.abs(vel) * .35) * it.dir * (i % 2 ? -1 : 1);
        if (it.w) { if (it.x <= -it.w) it.x += it.w; if (it.x > 0) it.x -= it.w; }
        it.el.style.transform = 'translate3d(' + it.x + 'px,0,0) skewX(' + clamp(-vel * .4, -12, 12) + 'deg)';
      });
      requestAnimationFrame(loop);
    })();
  }

  /* ---------- Reveal ---------- */
  function reveals() {
    $$('.zk-sec-head, .zk-card, .zk-radar__copy, .zk-radar__screen, .zk-crew__inner, .zk-news__inner, .zk-footer__top, .zk-coll__hero, .zk-ccard').forEach(function (el, i) {
      el.setAttribute('data-reveal', ''); el.style.transitionDelay = ((i % 4) * 80) + 'ms';
    });
    var targets = $$('[data-reveal], [data-drop]');
    if (!('IntersectionObserver' in window)) { targets.forEach(function (t) { t.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -10% 0px' });
    targets.forEach(function (t) { io.observe(t); });
  }

  /* ---------- Scroll-linked effects ---------- */
  function scrollFx() {
    var giant = $('.zk-drop__giant'), drop = $('[data-drop]');
    var manifesto = $('[data-manifesto]'), words = [];
    var look = $('[data-look]'), track = look && $('[data-look-track]', look);
    var foot = $('[data-giant]');

    if (manifesto) {
      var p = $('[data-words]', manifesto), raw = p.textContent.trim(); p.textContent = '';
      raw.split(/\s+/).forEach(function (w) {
        var hl = /^\*.*\*[.,;:!?]?$/.test(w) || /^\*/.test(w);
        var s = document.createElement('span'); s.className = 'zk-word' + (hl ? ' is-hl' : '');
        s.textContent = w.replace(/\*/g, ''); p.appendChild(s); p.appendChild(document.createTextNode(' '));
        words.push(s);
      });
    }

    function onScroll() {
      var vh = innerHeight;
      if (giant && drop) {
        var r = drop.getBoundingClientRect();
        giant.style.setProperty('--shift', ((r.top / vh) * 18 - 6) + 'vw');
      }
      if (words.length) {
        var mr = manifesto.getBoundingClientRect();
        var prog = clamp((vh * .85 - mr.top) / (mr.height * .75), 0, 1);
        var n = Math.round(prog * words.length);
        for (var i = 0; i < words.length; i++) words[i].classList.toggle('is-lit', i < n);
      }
      if (track && innerWidth > 989) {
        var lr = look.getBoundingClientRect();
        var max = track.scrollWidth - innerWidth;
        var lp = clamp(-lr.top / (lr.height - vh), 0, 1);
        track.style.transform = 'translate3d(' + (-lp * max) + 'px,0,0)';
        $$('.zk-look__img img', track).forEach(function (img, i) { img.style.setProperty('--par', (lp * 40 - 20) + 'px'); });
      }
    }
    if (!reduce) { addEventListener('scroll', onScroll, { passive: true }); addEventListener('resize', onScroll); onScroll(); }
    else { words.forEach(function (w) { w.classList.add('is-lit'); }); }

    if (foot && finePointer && !reduce) {
      var letters = $$('span', foot);
      foot.addEventListener('pointermove', function (e) {
        letters.forEach(function (l) {
          var r = l.getBoundingClientRect(), d = Math.abs(e.clientX - (r.left + r.width / 2));
          l.style.setProperty('--y', (-Math.max(0, 1 - d / 300) * 18) + '%');
        });
      });
      foot.addEventListener('pointerleave', function () { letters.forEach(function (l) { l.style.setProperty('--y', '0%'); }); });
    }
  }

  /* ---------- Tilt cards ---------- */
  function tilt() {
    if (!finePointer || reduce) return;
    $$('[data-tilt]').forEach(function (c) {
      c.addEventListener('pointermove', function (e) {
        var r = c.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
        c.style.transform = 'perspective(900px) rotateY(' + x * 8 + 'deg) rotateX(' + -y * 8 + 'deg)';
      });
      c.addEventListener('pointerleave', function () { c.style.transform = ''; });
    });
  }

  /* ---------- Size radar ---------- */
  function sizeRadar() {
    $$('[data-size-radar]').forEach(function (root) {
      var sizes = (root.dataset.sizes || 'XS,S,M,L,XL').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      var refH = +root.dataset.refH || 180, refW = +root.dataset.refW || 80, refS = (root.dataset.refSize || 'L').trim();
      var refIdx = Math.max(0, sizes.indexOf(refS));
      var inH = $('[data-in-h]', root), inW = $('[data-in-w]', root), outH = $('[data-out-h]', root), outW = $('[data-out-w]', root);
      var res = $('[data-size-out]', root), note = $('[data-size-note]', root), blip = $('[data-blip]', root);
      var fit = 0, last = '';
      function fill(i) { i.style.setProperty('--fill', ((i.value - i.min) / (i.max - i.min) * 100) + '%'); }
      function calc() {
        var h = +inH.value, w = +inW.value;
        outH.textContent = h; outW.textContent = w; fill(inH); fill(inW);
        var score = (h - refH) / 8 + (w - refW) / 9 + fit * 1;
        var idx = clamp(Math.round(refIdx + score * .62), 0, sizes.length - 1);
        var s = sizes[idx];
        if (s !== last) { res.classList.remove('is-pop'); void res.offsetWidth; res.classList.add('is-pop'); last = s; }
        res.textContent = s;
        note.textContent = fit < 0 ? 'COUPE AJUSTÉE' : fit > 0 ? 'COUPE OVERSIZE' : 'COUPE NORMALE';
        var a = ((h - 150) / 55) * Math.PI * 2, rad = 18 + ((w - 45) / 85) * 26;
        blip.style.setProperty('--bx', (50 + Math.cos(a) * rad) + '%');
        blip.style.setProperty('--by', (50 + Math.sin(a) * rad) + '%');
      }
      var pick = $('[data-size-pick]', root), pickL = $('[data-size-pick-label]', root);
      if (pick) pick.addEventListener('click', function () {
        var size = res.textContent.trim(), form = $('[data-buy]');
        if (!form) return;
        var inp = $$('.zk-opt__input', form).filter(function (i) { return i.value.trim().toUpperCase() === size.toUpperCase(); })[0];
        if (inp) { inp.checked = true; inp.dispatchEvent(new Event('change', { bubbles: true })); }
        form.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
      var _calc = calc; calc = function () { _calc(); if (pickL) pickL.textContent = res.textContent; };
      inH.addEventListener('input', calc); inW.addEventListener('input', calc);
      $$('[data-fit]', root).forEach(function (b) {
        b.addEventListener('click', function () {
          fit = +b.dataset.fit;
          $$('[data-fit]', root).forEach(function (x) { x.classList.toggle('is-on', x === b); x.setAttribute('aria-pressed', x === b); });
          calc();
        });
      });
      calc();
    });
  }

  /* ---------- Solid header once past the hero ---------- */
  function solidHeader() {
    var hs = $('.zk-header-section'); if (!hs) return;
    var hero = $('.zk-hero');
    var ann = $('.zk-annonce');
    function run() {
      var limit = hero ? hero.offsetTop + hero.offsetHeight - 80 : 40;
      hs.classList.toggle('is-solid', scrollY > limit);
      var a = ann ? ann.offsetHeight : 0;
      hs.style.top = Math.max(0, a - scrollY) + 'px';
    }
    run(); addEventListener('scroll', run, { passive: true }); addEventListener('resize', run);
  }

  /* ---------- Menu ---------- */
  function menu() {
    var m = $('[data-menu]'), open = $('[data-menu-open]');
    if (!m || !open) return;
    function set(on) {
      m.classList.toggle('is-open', on); m.setAttribute('aria-hidden', !on); open.setAttribute('aria-expanded', on);
      document.documentElement.classList.toggle('menu-open', on);
      document.documentElement.style.overflow = on ? 'hidden' : '';
      if (on) { var c = $('[data-menu-close]', m); c && c.focus(); } else open.focus();
    }
    open.addEventListener('click', function () { set(true); });
    $$('[data-menu-close]', m).forEach(function (b) { b.addEventListener('click', function () { set(false); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && m.classList.contains('is-open')) set(false); });
  }

  /* ---------- Cart ---------- */
  var Cart = {
    drawer: null,
    init: function () {
      this.drawer = $('[data-drawer]'); if (!this.drawer) return;
      var self = this;
      $$('[data-drawer-open]').forEach(function (b) { b.addEventListener('click', function (e) { if (e.metaKey || e.ctrlKey) return; e.preventDefault(); self.open(); }); });
      $$('[data-drawer-close]', this.drawer).forEach(function (b) { b.addEventListener('click', function () { self.close(); }); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && self.drawer.classList.contains('is-open')) self.close(); });
      this.drawer.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-line-change]'); if (!btn) return;
        self.change(btn.dataset.key, +btn.dataset.qty);
      });
      this.refresh();
    },
    open: function () {
      this.drawer.classList.add('is-open'); this.drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      $('.zk-drawer__panel', this.drawer).focus();
      this.refresh();
    },
    close: function () {
      this.drawer.classList.remove('is-open'); this.drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
    },
    refresh: function () {
      var self = this;
      return fetch((ZK.routes.cart || '/cart') + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); }).then(function (c) { self.render(c); return c; }).catch(function () {});
    },
    change: function (key, qty) {
      var self = this;
      return fetch((ZK.routes.cartChange || '/cart/change') + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json(); }).then(function (c) { self.render(c); });
    },
    img: function (url) { if (!url) return ''; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=240'; },
    esc: function (s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; },
    render: function (c) {
      var self = this, L = ZK.labels;
      $$('[data-cart-count]').forEach(function (n) {
        if (n.textContent != c.item_count) { var b = n.closest('.zk-cartbtn'); if (b) { b.classList.remove('is-bump'); void b.offsetWidth; b.classList.add('is-bump'); } }
        n.textContent = c.item_count;
      });
      var tot = $('[data-cart-total]'); if (tot) tot.textContent = money(c.total_price);
      var box = $('[data-cart-items]'); if (!box) return;
      var co = $('[data-checkout]'); if (co) co.disabled = !c.item_count;
      if (!c.items.length) { box.innerHTML = '<p class="zk-drawer__empty mono">' + self.esc(L.empty) + '</p>'; }
      else {
        box.innerHTML = c.items.map(function (it) {
          var variant = it.product_has_only_default_variant ? '' : '<p class="mono zk-muted">' + self.esc(it.variant_title) + '</p>';
          return '<div class="zk-line">' +
            '<a class="zk-line__img" href="' + it.url + '">' + (it.image ? '<img src="' + self.img(it.image) + '" alt="' + self.esc(it.product_title) + '" loading="lazy">' : '') + '</a>' +
            '<div class="zk-line__info"><a class="zk-line__t" href="' + it.url + '">' + self.esc(it.product_title) + '</a>' + variant +
            '<p class="mono">' + money(it.final_price) + '</p>' +
            '<div class="zk-line__row"><div class="zk-qty">' +
            '<button type="button" data-line-change data-key="' + it.key + '" data-qty="' + (it.quantity - 1) + '" aria-label="Diminuer">−</button>' +
            '<input type="number" value="' + it.quantity + '" readonly aria-label="Quantité">' +
            '<button type="button" data-line-change data-key="' + it.key + '" data-qty="' + (it.quantity + 1) + '" aria-label="Augmenter">+</button></div>' +
            '<button type="button" class="mono zk-line__rm" data-line-change data-key="' + it.key + '" data-qty="0">' + self.esc(L.remove || 'Retirer') + '</button></div></div>' +
            '<strong class="zk-line__tot">' + money(it.final_line_price) + '</strong></div>';
        }).join('');
      }
      if (ZK.freeShip > 0) {
        var left = ZK.freeShip - c.total_price, pct = clamp(c.total_price / ZK.freeShip * 100, 0, 100);
        $$('[data-ship]').forEach(function (ship) {
          var was = ship.classList.contains('is-ok');
          $('[data-ship-bar]', ship).style.width = pct + '%';
          $('[data-ship-text]', ship).textContent = left > 0 ? (L.freeLeft || '').replace('[montant]', money(left)) : L.freeOk;
          ship.classList.toggle('is-ok', left <= 0);
          if (left <= 0 && !was) { ship.classList.remove('is-pop'); void ship.offsetWidth; ship.classList.add('is-pop'); }
        });
      }
    },
    add: function (form) {
      var fd = new FormData(form);
      return fetch((ZK.routes.cartAdd || '/cart/add') + '.js', {
        method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd
      }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
    }
  };

  /* ---------- Product forms ---------- */
  function products() {
    $$('[data-buy]').forEach(function (root) {
      var json = $('[data-product-json]', root); if (!json) return;
      var product; try { product = JSON.parse(json.textContent); } catch (e) { return; }
      var form = $('[data-product-form]', root) || $('form', root);
      var idInput = $('[data-variant-id]', root), add = $('[data-add]', root), addLabel = $('[data-add-label]', root), msg = $('[data-buy-msg]', root);
      var scope = root.closest('section') || document;
      var isPdp = !!root.closest('[data-pdp]');
      var fieldsets = $$('[data-option-index]', root);

      function selected() { return fieldsets.map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; }); }
      function find(vals) { return product.variants.find(function (v) { return v.options.every(function (o, i) { return o === vals[i]; }); }); }
      function availability() {
        var vals = selected();
        fieldsets.forEach(function (fs, idx) {
          $$('input', fs).forEach(function (inp) {
            var test = vals.slice(); test[idx] = inp.value;
            var v = find(test);
            var lab = inp.nextElementSibling; if (lab) lab.classList.toggle('is-out', !v || !v.available);
          });
        });
      }
      function update() {
        var vals = selected(), v = find(vals);
        fieldsets.forEach(function (fs, i) { var l = $('[data-option-label]', fs); if (l) l.textContent = vals[i] || ''; });
        availability();
        if (!v) { add.disabled = true; addLabel.textContent = ZK.labels.unavailable || 'Indisponible'; return; }
        idInput.value = v.id;
        add.disabled = !v.available;
        addLabel.textContent = v.available ? (ZK.labels.add || 'Ajouter') : (ZK.labels.soldout || 'Épuisé');
        var pw = $('[data-price-wrap]', scope);
        if (pw) {
          $('[data-price]', pw).textContent = money(v.price);
          var cmp = $('[data-compare]', pw), sv = $('[data-saving]', pw);
          if (v.compare_at_price > v.price) {
            cmp.hidden = false; cmp.textContent = money(v.compare_at_price);
            sv.hidden = false; sv.textContent = '-' + Math.round((v.compare_at_price - v.price) / v.compare_at_price * 100) + '%';
          } else { cmp.hidden = true; sv.hidden = true; }
        }
        var sp = $('[data-sticky-price]'); if (sp && isPdp) sp.textContent = money(v.price);
        if (isPdp && history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString()); }
        if (isPdp && v.featured_media) {
          var m = $('[data-media-id="' + v.featured_media.id + '"]');
          if (m) { var rail = m.parentElement; if (innerWidth <= 989) rail.scrollTo({ left: m.offsetLeft, behavior: 'smooth' }); }
        }
      }
      fieldsets.forEach(function (fs) { fs.addEventListener('change', update); });
      if (fieldsets.length) availability();

      var qty = $('[data-qty]', root);
      if (qty) {
        var qi = $('input', qty);
        $('[data-qty-minus]', qty).addEventListener('click', function () { qi.value = Math.max(1, (+qi.value || 1) - 1); });
        $('[data-qty-plus]', qty).addEventListener('click', function () { qi.value = (+qi.value || 1) + 1; });
      }

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (add.disabled) return;
        add.classList.add('is-loading'); add.setAttribute('aria-busy', 'true');
        Cart.add(form).then(function () {
          msg.textContent = ZK.labels.added || '';
          setTimeout(function () { msg.textContent = ''; }, 3000);
          if (Cart.drawer) Cart.open(); else location.href = ZK.routes.cart || '/cart';
        }).catch(function (err) {
          msg.textContent = (err && (err.description || err.message)) || 'Erreur, réessaie.';
        }).then(function () { add.classList.remove('is-loading'); add.removeAttribute('aria-busy'); });
      });

      if (isPdp) {
        var bar = $('[data-stickybar]'), sAdd = $('[data-sticky-add]');
        if (bar && sAdd && 'IntersectionObserver' in window) {
          new IntersectionObserver(function (en) {
            var on = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
            bar.classList.toggle('is-on', on); bar.setAttribute('aria-hidden', !on);
          }).observe(add);
          sAdd.addEventListener('click', function () {
            if (add.disabled) { add.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
            form.requestSubmit ? form.requestSubmit() : add.click();
          });
        }
      }
    });
  }

  /* ---------- PDP gallery ---------- */
  function gallery() {
    var g = $('[data-gallery]'); if (!g) return;
    var rail = $('.zk-pdp__rail', g), dots = $$('.zk-pdp__dots i', g);
    if (rail && dots.length) rail.addEventListener('scroll', function () {
      var i = Math.round(rail.scrollLeft / rail.clientWidth);
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
    }, { passive: true });
    var lb = $('[data-lightbox]'), lbi = lb && $('[data-lightbox-img]', lb);
    if (!lb) return;
    $$('[data-zoom]', g).forEach(function (b) {
      b.addEventListener('click', function () { lbi.src = b.dataset.zoom; lb.classList.add('is-open'); lb.setAttribute('aria-hidden', 'false'); $('[data-lightbox-close]', lb).focus(); });
    });
    function close() { lb.classList.remove('is-open'); lb.setAttribute('aria-hidden', 'true'); }
    lb.addEventListener('click', function (e) { if (e.target === lb || e.target.closest('[data-lightbox-close]')) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ---------- Related products ---------- */
  function related() {
    $$('[data-related]').forEach(function (el) {
      if (!el.dataset.url) return;
      fetch(el.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
        var d = document.createElement('div'); d.innerHTML = html;
        var n = d.querySelector('[data-related]');
        if (n && n.innerHTML.trim()) { el.innerHTML = n.innerHTML; tilt(); reveals(); }
      }).catch(function () {});
    });
  }

  /* ---------- Sort ---------- */
  function sort() {
    var s = $('[data-sort]'); if (!s) return;
    s.addEventListener('change', function () { var u = new URL(location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page'); location.href = u.toString(); });
  }

  /* ---------- Sound ---------- */
  function sound() {
    var b = $('[data-sound]'), a = $('[data-sound-audio]'); if (!b || !a) return;
    a.volume = .45;
    b.addEventListener('click', function () {
      var on = a.paused;
      if (on) a.play().catch(function () {}); else a.pause();
      b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on);
      $('.zk-sound__txt', b).textContent = on ? 'SON ON' : 'SON OFF';
    });
  }

  /* ---------- Boot ---------- */
  function boot() {
    splitChars(); fitLines();
    document.addEventListener('zk:ready', function () {
      requestAnimationFrame(function () { $$('.zk-hero__title, .zk-hero').forEach(function (e) { e.classList.add('is-in'); }); });
    }, { once: true });
    loader();
    clocks(); scramble(); cursor(); buttons(); storm(); heroFx(); marquees();
    reveals(); scrollFx(); tilt(); sizeRadar(); menu(); solidHeader();
    Cart.init(); products(); gallery(); related(); sort(); sound();
    if (!$('[data-loader]')) $$('.zk-hero').forEach(function (e) { e.classList.add('is-in'); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
